<template>
  <div>
    <div v-if="showLeadsDuplicates">
      <lead-duplicates />
    </div>
    <div v-else id="lead-table">
      <v-row align="center" justify="center">
        <v-col cols="11 " class="justify-center">
          <LeadSearchField style="padding-top: 2rem;" />
        </v-col>
      </v-row>
      <section style="display: flex;" class="mx-4 multiple-actions ">
        <lead-export-clipboard-button
          class="export-clipboard"
          @select="selectAllLeads"
        />
        <leads-reassigned
          v-if="role === 'admin'"
          class="mx-4 reassigned-multi"
          ref="refLeadReassigned"
          @close="onCloseReassignLeadModel"
        />
      </section>
      <SkeletonTableLead
        v-if="leadsPaginationLoadingSt && leads.length === 0"
      />
      <ErrorViewTableLead
        v-else-if="someFilterSelected && leads.length <= 0"
        title="No se encontraron Leads con los filtros seleccionados."
        message="Intenta seleccionado otros filtros o puedes utilizar el buscador que se encuentra en la parte de arriba si prefieres."
      />
      <ErrorViewTableLead v-else-if="leads.length <= 0" />
      <article v-else>
        <section class="bar__config"><HeadersConfig /></section>
        <v-data-table
          id="leadsTable"
          v-model="selectedItems"
          :headers="headers"
          :item-key="'_id'"
          :items="filterLeadsSearchedSt ? leadsSearchedSt : leads"
          :page="page"
          :items-per-page="filterLeadsSearchedSt ? 10 : itemsPerPage"
          class="elevation-2 mx-4 mb-16"
          loading-text="Cargando leads ..."
          :options.sync="options"
          :show-select="
            role === 'admin' || role === 'marketing' || role === 'marketingv2'
          "
          hide-default-footer
        >
          <template
            v-for="(h, index) in headers"
            v-slot:[`item.${h.value}`]="{ value }"
          >
            <TableCustomField
              v-if="h.value.includes('custom_fields')"
              :key="index"
              :type="h.type"
              :value="value"
            />
            <template v-else>{{ value }}</template>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              fab
              v-if="role !== 'marketing'"
              elevation="0"
              color="blue lighten-5"
              small
              class="text-center button__detail"
              @click="setActualLead(item._id)"
            >
              <v-icon color="cyan darken-4">
                mdi-eye
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.contact_lead.name`]="{ item }">
            <div class="text-caption text--secondary">
              {{ item.created_at | dateFormat(true) }}
            </div>
            <v-edit-dialog
              v-if="role === 'admin' || role === 'broker'"
              save-text="Guardar"
              cancel-text="Cancelar"
              large
              @save="
                updateLead(item._id, item.contact_lead._id, {
                  name: name
                })
              "
              :return-value.sync="name"
              @cancel="cancel"
              @open="open"
              @close="dialogClosed()"
            >
              <div
                v-if="item && item.contact_lead"
                v-bind:class="item_row_background(item)"
                class="text-body-1"
                @click="setComputedName(item.contact_lead.name)"
              >
                {{ item.contact_lead.name }}
              </div>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar</div>
                <v-text-field
                  v-model="name"
                  placeholder="Ingresa el nombre"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
            <div
              v-else
              v-bind:class="item_row_background(item)"
              class="text-body-1"
            >
              {{ item.contact_lead.name }}
            </div>
          </template>
          <template v-slot:[`item.contact_lead.phone`]="{ item }">
            <v-edit-dialog
              save-text="Guardar"
              cancel-text="Cancelar"
              v-if="item && showInfoDev(role)"
              :return-value.sync="phone"
              large
              @save="
                updateLead(item._id, item.contact_lead._id, {
                  contact_lead_phone: formatPhone(phone)
                })
              "
              @cancel="cancel"
              @open="open"
              @close="dialogClosed()"
            >
              <div
                @click="setComputedPhone(item.contact_lead.phone)"
                v-bind:class="item_row_background(item)"
                class="font-size-table-row"
              >
                <div v-if="item.contact_lead.phone">
                  <v-menu
                    open-on-hover
                    offset-y
                    top
                    color="primary"
                    min-width="10"
                    nudge-top="5"
                    close-delay="500"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ on, attrs, value }">
                      <div v-on="on" v-bind="attrs">
                        {{ item.contact_lead.phone }}

                        <v-icon v-if="value" small>
                          mdi-pencil
                        </v-icon>
                      </div>
                    </template>
                    <LeadContactActions
                      type="phone"
                      :value="item.contact_lead.phone"
                      :lead-id="item._id"
                      :contact-lead-id="item.contact_lead._id"
                    />
                  </v-menu>
                </div>
                <div v-else class="grey--text">
                  -
                </div>
              </div>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar</div>
                <v-text-field
                  v-model="phone"
                  placeholder="Ingresa el teléfono"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:[`item.contact_lead.email`]="{ item }">
            <v-edit-dialog
              save-text="Guardar"
              cancel-text="Cancelar"
              v-if="item && showInfoDev(role)"
              :return-value.sync="email"
              large
              @save="
                updateLead(item._id, item.contact_lead._id, {
                  contact_lead_email: email
                })
              "
              @cancel="cancel"
              @open="open"
              @close="dialogClosed()"
            >
              <div
                v-bind:class="item_row_background(item)"
                class="font-size-table-row"
                @click="setComputedEmail(item.contact_lead.email)"
              >
                <div v-if="item.contact_lead.email">
                  <v-menu
                    open-on-hover
                    top
                    offset-y
                    color="primary"
                    min-width="10"
                    nudge-top="5"
                    close-delay="500"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ on, attrs, value }">
                      <div v-on="on" v-bind="attrs">
                        {{ item.contact_lead.email }}
                        <v-icon v-if="value" small>
                          mdi-pencil
                        </v-icon>
                      </div>
                    </template>
                    <LeadContactActions
                      type="email"
                      :value="item.contact_lead.email"
                      :lead-id="item._id"
                      :contact-lead-id="item.contact_lead._id"
                    />
                  </v-menu>
                </div>
                <div v-else class="grey--text">
                  -
                </div>
              </div>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar</div>
                <v-text-field
                  v-model="email"
                  placeholder="Ingresa el Correo"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:[`item.zones`]="{ item }">
            <div v-if="item && item.zones" class="font-size-table-row">
              {{ item.zones }}
            </div>
            <div v-else class="font-size-table-row">
              -
            </div>
          </template>
          <template v-slot:[`item.category`]="{ item }">
            <HelperMessage v-if="item.category" :color="item.category.color">
              <v-chip small :color="item.category.color" outlined>
                {{ item.category.code }}
              </v-chip>
              <template #message>
                <span>{{ item.category.description }}</span>
              </template>
            </HelperMessage>
            <div v-else class="font-size-table-row">
              -
            </div>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            <v-edit-dialog
              save-text="Guardar"
              cancel-text="Cancelar"
              :return-value.sync="item.budget"
              large
              @save="
                updateLead(item._id, item.contact_lead._id, {
                  budget: item.budget
                })
              "
              @cancel="cancel"
              @open="open"
            >
              <div v-if="item">
                <div class="text-right lead-budget">
                  {{ priceFormat(item.budget, item.currency) }}
                </div>
              </div>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar</div>
                <v-text-field
                  :value="item.budget"
                  @change="
                    value => (value.includes('.') ? '' : (item.budget = value))
                  "
                  label="Escribe el presupuesto"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            <div
              v-if="item && item.contact && item.contact.source"
              class="d-flex align-center source-cell"
            >
              <v-avatar size="22" class="source-icon mr-1">
                <v-img
                  contain
                  :src="
                    item.contact.source.media
                      ? item.contact.source.media.src
                      : ''
                  "
                />
              </v-avatar>
              <span class="text-caption source-name">
                {{ item.contact.source.name }}
              </span>
            </div>
            <span v-else class="grey--text text--lighten-1">—</span>
          </template>
          <template v-slot:[`item.internal_broker`]="{ item }">
            <lead-assign :lead="item" />
          </template>
          <template v-slot:[`item.tracking_phase`]="{ item }">
            <lead-select-phase :lead="item" />
          </template>
          <template v-slot:[`item.postponed.date_at`]="{ item }">
            <lead-postpone-action
              :postponed="item.postponed ? item.postponed.date_at : ''"
              :leadId="item._id"
              :lead="item"
              @updateDate="date => (item.postponed.date_at = date)"
            />
          </template>
          <template v-slot:[`item.multi_sales_opportunities`]="{ item }">
            <Tags-And-Create
              :itsImmediate="itsImmediate(item.created_at, item.reviewed)"
              :brex="item.contact_external_broker_id ? true : false"
              :lead="item"
            />
          </template>
          <template v-slot:[`item.contact_lead.duplicated`]="{ item }">
            <v-tooltip v-if="item.contact_lead.duplicated" bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="error" v-on="on">mdi-content-copy</v-icon>
              </template>
              <span>Lead duplicado</span>
            </v-tooltip>
            <span v-else class="grey--text text--lighten-1">—</span>
          </template>
          <template v-slot:[`item.contact_match`]="{ item }">
            <Contact-Match-Button :lead="item" />
            <span
              v-if="!item.contact_match && !item.unified_contact_id"
              class="grey--text text--lighten-1"
              >—</span
            >
          </template>
          <template v-slot:[`item.contact_attempts`]="{ item }">
            <v-tooltip v-if="hasContactAttempts(item)" bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="font-weight-medium">
                  {{ contactAttemptsTotal(item) }}
                </span>
              </template>
              <div>
                <div
                  v-for="attempt in item.contact_attempts"
                  :key="attempt.source"
                  class="d-flex align-center"
                >
                  <v-icon x-small color="white" class="mr-1">
                    {{ contactAttemptIcon(attempt.source) }}
                  </v-icon>
                  {{ contactAttemptLabel(attempt.source) }}:
                  {{ attempt.attempts }}
                </div>
              </div>
            </v-tooltip>
            <span v-else class="grey--text text--lighten-1">0</span>
          </template>
          <template v-slot:footer>
            <v-row
              class="pagination-footer ma-0 pa-0 py-2 px-5"
              align="center"
              justify="end"
            >
              <span class="caption">Leads por página</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="filterLeadsSearchedSt"
                    dark
                    text
                    color="primary"
                    class="ml-1"
                  >
                    {{ leadsSearchedSt.length }}
                  </v-btn>
                  <v-btn
                    v-else
                    dark
                    text
                    color="primary"
                    class="ml-0 caption"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray(
                      filterLeadsSearchedSt
                        ? leadsSearchedSt.length
                        : leadsTableFooterSt.total
                    )"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <span class="mr-4 caption">
                {{ getTextFooter() }}
              </span>
              <v-btn
                icon
                color="primary"
                class="mr-1"
                small
                :disabled="page === 1"
                @click="previousPage()"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                v-if="filterLeadsSearchedSt"
                icon
                color="primary"
                class="ml-1"
                small
                :disabled="
                  page === Math.ceil(leadsSearchedSt.length / itemsPerPage)
                "
                @click="nextPage()"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                color="primary"
                class="ml-1"
                small
                :disabled="page === Math.ceil(leads.length / itemsPerPage)"
                @click="nextPage()"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
          </template>
        </v-data-table>
      </article>
    </div>
    <lead-detail-modal
      ref="leadDetailModal"
      :page="'table'"
      :dialog="isDialogActive"
      @setDialog="setDialog"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { GetContactLeadDuplicate } from "@/api/contacts-api.js";
import HeadersConfig from "./components/tableLead/HeadersConfig.vue";
import SkeletonTableLead from "./components/tableLead/SkeletonTableLead.vue";
import ErrorViewTableLead from "./components/tableLead/ErrorViewTableLead.vue";
moment.locale("es");

export default {
  components: {
    LeadSearchField: () => import("@/components/lead/LeadSearchField.vue"),
    LeadPostponeAction: () => import("@/components/lead/LeadPostpone.vue"),
    LeadDuplicates: () => import("@/components/lead/LeadDuplicates.vue"),
    LeadDetailModal: () => import("@/components/lead/LeadDetailModal.vue"),
    LeadsReassigned: () => import("@/components/lead/LeadsReassigned.vue"),
    LeadExportClipboardButton: () =>
      import("@/components/lead/LeadExportClipboardButton"),
    LeadContactActions: () =>
      import("@/components/lead/LeadContactActions.vue"),

    LeadAssign: () => import("@/components/lead/LeadAssign.vue"),
    LeadSelectPhase: () => import("@/components/lead/LeadSelectPhase.vue"),
    ContactMatchButton: () =>
      import(
        "@/components/lead/components/tagsComponents/IconContactMatch.vue"
      ),
    TagsAndCreate: () =>
      import("@/components/lead/components/IconTagsLead.vue"),
    HeadersConfig,
    SkeletonTableLead,
    ErrorViewTableLead,
    TableCustomField: () =>
      import("@/components/lead/components/TableCustomField.vue"),
    HelperMessage: () => import("@/components/common/HelperMessage.vue")
  },
  data() {
    return {
      selectedAllLeads: false,
      page: 1,
      itemsPerPage: 10,
      menusLinks: [],
      menusContactLinks: [],
      role: localStorage.getItem("user_role"),
      user: null,
      publicPath: process.env.BASE_URL,
      options: {},
      snack: false,
      snackColor: "",
      snackText: "",
      isDialogActive: false,
      name: "",
      email: "",
      phone: ""
    };
  },
  watch: {
    filterLeadsSearchedSt(newValue) {
      if (!newValue) {
        this.itemsPerPage = 10;
      }
    },
    leads(newValue) {
      for (let i = 0; i < newValue.length; i++) {
        this.menusLinks.push(false);
        this.menusContactLinks.push(false);
      }
    },
    leadProfile(newValue) {
      let profileNumber = 0;
      switch (newValue) {
        case "A":
          profileNumber = 3;
          break;
        case "B":
          profileNumber = 2;
          break;
        case "C":
          profileNumber = 1;
          break;
        case "D":
          profileNumber = 0;
          break;
        default:
          profileNumber = 0;
          break;
      }
      this.slider = profileNumber;
    },
    itemsPerPage(newValue) {
      if (newValue != this.options) {
        this.fetchLeadsleadsPaginationSt({
          filter: this.filtersSelectedSt,
          page: 0,
          limit: newValue,
          footer: null
        });
        this.options.itemsPerPage = newValue;
      }
    },
    options: {
      handler() {
        //this.getDataFromApi();
        this.changePage(this.options);
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      loading: state => state.leads.loading,
      lead: state => state.leads.actualItem,
      showLeadsDuplicates: state =>
        state.leads.filter.filterShowLeadsDuplicates,
      leadsPaginationLoadingSt: state => state.leads.leadsPaginationLoading,
      leadsTableFooterSt: state => state.leads.leadsTableFooter,
      leadsSearchedSt: state => state.leads.leadsSearched,
      filterLeadsSearchedSt: state => state.leads.filterLeadsSearched,
      filtersSelectedSt: state => state.leads.filter.filtersSelected,
      someFilterSelected: state => state.leads.filter.filterSomeFilterSelected
    }),
    ...mapGetters("leads", {
      leads: "filteredLeads",
      headers: "headers/headersTable"
    }),
    selectedItems: {
      get() {
        return this.$store.state.leads.selectedItems;
      },
      set(newValue) {
        this.$store.commit("leads/setSelectedItems", newValue);
      }
    },
    leadProfile: {
      get() {
        if (this.lead && this.lead.profile) return this.lead.profile;
        return "";
      },
      set: function(newValue) {
        this.$store.commit("leads/updateActualLead", {
          profile: newValue
        });
      }
    }
  },
  filters: {
    dateFormat(date, isFullDate = false) {
      if (!date) return "";
      let format = "DD-MMM-YYYY";
      if (isFullDate) format = "DD-MMM-YYYY h:mm a";
      let dateParsed = moment(String(date)).format(format);
      return dateParsed;
    },
    percentageFormat(percentage) {
      if (!percentage || isNaN(percentage)) return 0;
      let percentageParsed = parseInt(percentage);
      return percentageParsed;
    }
  },
  async mounted() {
    this.fetchGetLeadsFiltersSt();
    // bajamos el limite a 10 para evitar posibles duplicidades
    this.fetchLeadsleadsPaginationSt({
      filter: this.filtersSelectedSt,
      page: 0,
      limit: 10,
      footer: null
    });
  },
  beforeDestroy() {
    this.setLeadsTableFooterSt({
      page: 0,
      pages: 0,
      total: 0
    });
  },
  created() {},
  methods: {
    ...mapActions({
      fetchUpdatelLead: "leads/fetchUpdatelLead",
      fetchActualLead: "leads/fetchActualLead",
      fetchLeadsleadsPaginationSt: "leads/fetchLeadsPagination",
      fetchGetLeadsFiltersSt: "leads/filter/fetchGetLeadsFilters"
    }),
    ...mapMutations({
      setLoading: "leads/setLoading",
      updateActualLead: "leads/updateActualLead",
      setLeadsTableFooterSt: "leads/setLeadsTableFooter",
      setLeadsPaginationSt: "leads/setLeadsPagination",
      setFiltersSelectedSt: "leads/setFiltersSelected",
      setFiltersSelectedChangedSt: "leads/filter/setFiltersSelectedChanged",
      setLeadsPaginationClearSt: "leads/setLeadsPaginationClear",
      setSecondaryLead: "leads/setSecondaryLead",
      setLeadsDuplicados: "leads/setLeadsDuplicados"
    }),
    selectAllLeads(value) {
      this.$refs.refLeadReassigned.selectedAll(value);
    },
    updateItemsPerPage(num) {
      this.itemsPerPage = num;
    },
    changePage(options) {
      // Esto es para evitar que se ciclen las peticiones cuando el usuario cambia de pagina
      // solo permite estar 1 pagina adelante
      if (options.page + 1 === this.leadsTableFooterSt.page) return;
      this.page = options.page;
      this.itemsPerPage = options.itemsPerPage;
      let currentLeads = options.page * options.itemsPerPage;
      let lessLeads = this.leads.length - currentLeads;
      if (
        this.leadsTableFooterSt.page + 1 <
        Math.ceil(this.leadsTableFooterSt.pages)
      ) {
        if (this.leads && this.leads.length > 0 && lessLeads <= 50) {
          if (!this.leadsTableFooterSt.more) {
            this.leadsTableFooterSt.more = true;
            this.leadsTableFooterSt.page = this.leadsTableFooterSt.page + 1;
            this.setLeadsTableFooterSt(this.leadsTableFooterSt);
            if (this.itemsPerPage === this.leadsTableFooterSt.total) {
              this.setLeadsPaginationSt([]);
              this.fetchLeadsleadsPaginationSt({
                filter: this.filtersSelectedSt,
                page: 0,
                limit: this.itemsPerPage,
                footer: null
              });
            } else {
              //TODO: Aqui esta el problema del paginado
              this.fetchLeadsleadsPaginationSt({
                filter: this.filtersSelectedSt,
                page: this.leadsTableFooterSt
                  ? this.leadsTableFooterSt.page
                  : 0,
                // tener cuidado con este paginado
                limit: this.itemsPerPage,
                footer: this.leadsTableFooterSt
              });
            }
          }
        }
      }
    },
    getTextFooter() {
      let c = this.itemsPerPage * this.page;
      let f = c + 1;
      if (this.filterLeadsSearchedSt) {
        if (
          this.page ===
          Math.ceil(this.leadsSearchedSt.length / this.itemsPerPage)
        ) {
          return `${f - this.itemsPerPage} - ${
            this.leadsSearchedSt.length
          } de ${this.leadsSearchedSt.length}`;
        } else {
          return `${f - this.itemsPerPage} - ${this.itemsPerPage *
            this.page} de ${this.leadsSearchedSt.length}`;
        }
      } else if (
        this.page === Math.ceil(this.leads.length / this.itemsPerPage)
      ) {
        return `${f - this.itemsPerPage} - ${this.leads.length} de ${
          this.leads.length
        }`;
      } else if (this.page === Math.ceil(this.leadsTableFooterSt.pages)) {
        return `${f - this.itemsPerPage} - ${this.itemsPerPage *
          this.page} de ${this.leadsTableFooterSt.total}`;
      } else {
        return `${f - this.itemsPerPage} - ${this.itemsPerPage *
          this.page} de ${this.leadsTableFooterSt.total}`;
      }
    },
    previousPage() {
      this.page = this.page !== 1 ? this.page - 1 : 1;
    },
    nextPage() {
      this.page++;
    },
    itemsPerPageArray(data) {
      let mount = [10, 25, 50];
      let final = [];
      for (let i = 0; i < mount.length; i++) {
        if (data > mount[i]) {
          final.push(mount[i]);
        }
      }
      final.push(data);
      return final;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    closeMenuAtLink(index) {
      this.menusLinks[index] = false;
    },
    closeMenuAtContactLink(index) {
      this.menusContactLinks[index] = false;
    },
    showInfoDev(role) {
      if (role === null || role === undefined || role === "") {
        return true;
      } else if (role === null || role === undefined) {
        return true;
      } else {
        return (
          role !== "developer" && role !== "marketing" && role !== "marketingv2"
        );
      }
    },
    onCloseReassignLeadModel(val) {
      if (val) {
        this.selectedItems = [];
      }
    },
    consultLeads() {
      let self = this;
      self.setLoading(true);
      setTimeout(() => {
        setTimeout(() => {
          self.setLoading(false);
        }, 1000);
      }, 1500);
    },
    formatPhone(phone) {
      if (phone) {
        return phone.includes("+")
          ? `+${phone.replace(/\D/g, "")}`
          : phone.replace(/\D/g, "");
      } else {
        return "";
      }
    },
    updateLeadList() {
      this.consultLeads();
    },
    async updateLead(leadId, contactLeadId, dataLead) {
      //Obtenemos el lead que se esta modificando
      //Find permite actualizar el objeto y a su vez el objeto en su array
      //No hay necesidad de actualizar el array
      //find es una extension del array
      const lead = this.leads.find(lead => lead._id === leadId);
      if (dataLead.name) {
        //Si el valor existe y es igual retornamos la funcion para que no haga la actualización
        if (lead.contact_lead.name === dataLead.name) {
          return true;
        }
        lead.contact_lead.name = dataLead.name;
      }

      if (dataLead.contact_lead_email) {
        if (lead.contact_lead.email === dataLead.contact_lead_email) {
          return true;
        }
        const isDuplicate = await this.isContactFieldDuplicate(
          "email",
          dataLead.contact_lead_email,
          contactLeadId
        );
        if (isDuplicate) return false;
        lead.contact_lead.email = dataLead.contact_lead_email;
      }
      if (dataLead.contact_lead_phone) {
        if (lead.contact_lead.phone === dataLead.contact_lead_phone) {
          return true;
        }
        const isDuplicate = await this.isContactFieldDuplicate(
          "phone",
          dataLead.contact_lead_phone,
          contactLeadId
        );
        if (isDuplicate) return false;
        lead.contact_lead.phone = dataLead.contact_lead_phone;
      }
      //this.lead.contact_lead.name = dataLead.name;
      this.handleUpdateLead(leadId, contactLeadId, dataLead);
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    async isContactFieldDuplicate(type, value, contactLeadId) {
      try {
        const response = await GetContactLeadDuplicate({
          [type]: value,
          contact_lead_id: contactLeadId
        });
        if (response.results > 0) {
          this.$snotify.warning(
            type === "email"
              ? "Este correo ya está registrado en otro lead."
              : "Este teléfono ya está registrado en otro lead.",
            "Duplicado detectado",
            {
              closeOnClick: true,
              titleMaxLength: 30,
              timeout: 4000
            }
          );
          return true;
        }
        return false;
      } catch (err) {
        // Si falla la verificación de duplicados, no bloqueamos la actualización
        return false;
      }
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    isWhatsappUrl(url) {
      return url.includes("rply.link");
    },
    openLink(url) {
      this.cancel();
      window.open(url);
      this.cancel();
    },
    handleUpdateLead(leadId, contactLeadId, dataLead) {
      // una vez cambiado el lead actual, actualizar el valor en Vuex
      let data = {
        leadId,
        contactLeadId,
        lead: dataLead
      };

      let self = this;
      this.$snotify.async(
        "Actualizando lead",
        "Actualizando ...",
        () =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              this.fetchUpdatelLead(data)
                .then(() => {
                  resolve({
                    title: "Lead editado",
                    body: "El lead se ha editado correctamente.",
                    config: {
                      closeOnClick: true,
                      titleMaxLength: 30,
                      timeout: 4000
                    }
                  });
                })
                .catch(err => {
                  reject({
                    title: "Error!!!",
                    body: `Ocurrio un problema actualizar el lead. ${err}`,
                    config: {
                      closeOnClick: true,
                      timeout: 4000
                    }
                  });
                })
                .finally(() => {
                  setTimeout(() => {
                    self.setLoading(false);
                  }, 1000);
                });
            }, 500);
          })
      );
    },
    // end listeners
    priceFormat(price, currency) {
      if (parseFloat(price) <= 0 || isNaN(price) || !price) {
        return "-";
      }
      let priceFormatted =
        "$" +
        parseFloat(price)
          // .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (currency) priceFormatted.concat(" " + currency);
      return priceFormatted;
    },

    async setActualLead(leadId) {
      let self = this;
      self.setLoading(true);
      self.setDialog(true);
      // resetear leads seleccionados (checkboxes)
      self.selectedItems = [];
      //this.$refs.leadDetailModal.getTrafficData();
      await this.fetchActualLead(leadId);
      // Se hace este parseo para que cuando mute el lead, no cambie el secundario
      let data = JSON.parse(JSON.stringify(this.lead));
      this.$store.commit("leads/setSecondaryLead", data);
      self.setLoading(false);
    },
    setDialog(isActive) {
      this.isDialogActive = isActive;
      if (!isActive) {
        this.$store.commit("leads/setLeadsDuplicados", {});
      }
    },
    item_row_background(item) {
      return item.IsDuplicated === true ? "row-repeat-lead" : "";
    },
    hasContactAttempts(item) {
      return (
        Array.isArray(item.contact_attempts) && item.contact_attempts.length > 0
      );
    },
    contactAttemptsTotal(item) {
      if (!this.hasContactAttempts(item)) return 0;
      return item.contact_attempts.reduce(
        (total, attempt) => total + (attempt.attempts || 0),
        0
      );
    },
    contactAttemptIcon(source) {
      switch (source) {
        case "whatsapp":
          return "mdi-whatsapp";
        case "call":
          return "mdi-phone";
        case "email":
          return "mdi-email";
        case "sms":
          return "mdi-message-text";
        default:
          return "mdi-help-circle-outline";
      }
    },
    contactAttemptLabel(source) {
      switch (source) {
        case "whatsapp":
          return "WhatsApp";
        case "call":
          return "Llamada";
        case "email":
          return "Correo";
        case "sms":
          return "SMS";
        default:
          return source;
      }
    },
    itsImmediate(created, reviewed) {
      if (reviewed) {
        if (reviewed.is_reviewed != null && reviewed.is_reviewed) {
          var diff = Math.abs(new Date(reviewed.date_at) - new Date(created));
          const diffMinutes = Math.floor(diff / 1000 / 60);
          return diffMinutes <= 5;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setComputedName(newValue) {
      this.name = newValue;
    },
    setComputedEmail(newValue) {
      this.email = newValue;
    },
    setComputedPhone(newValue) {
      this.phone = newValue;
    },
    dialogClosed() {
      this.name = "";
      this.email = "";
      this.phone = "";
    }
  }
};
</script>
<style>
/* Table header */
#leadsTable .v-data-table-header th {
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #546e7a !important;
  background: #f8f9fa !important;
  white-space: nowrap;
  border-bottom: 2px solid #e0e0e0 !important;
}

/* Row alternation */
#leadsTable tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Row hover */
#leadsTable tbody tr:hover td {
  background-color: rgba(66, 165, 245, 0.07) !important;
}

/* Cell padding */
#leadsTable td {
  border-bottom: 1px solid #f0f0f0 !important;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}

.font-size-table-header {
  font-size: 0.75rem !important;
}
.font-size-table-row {
  font-size: 14px !important;
}

.lead-phase-badge.discarded,
.v-chip.v-chip--outlined.v-chip.v-chip.discarded {
  background-color: #eee !important;
}
.lead-profile-badge.profile-a {
  background-color: #008000;
}
.lead-profile-badge.profile-b {
  background-color: #ffa500;
}
.lead-profile-badge.profile-c {
  background-color: #2e6cf1;
}
.lead-profile-badge.profile-d {
  background-color: #a0a0a0;
}
.VueTables__search,
.VueTables__limit {
  display: inline-block;
  padding: 12px 0;
  margin-bottom: 0;
}
.VueTables__limit {
  float: right;
}

.lead-budget {
  font-size: 14px;
  color: #008000;
}

.pagination-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
}
.text-ellips {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.button__detail {
  padding: 0.25rem !important;
}
.bar__config {
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: flex-end;
}
.source-icon {
  border: 1px solid #e0e0e0;
  background: #fff;
  flex-shrink: 0;
}
.source-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90px;
}
</style>
